/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
// import { Filter, Sliders } from "react-feather";
// import Select from "react-select";
import { useSelector } from 'react-redux';
import { Edit, Trash2 } from "react-feather";
import { PlusCircle } from 'feather-icons-react/build/IconComponents';

import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import ImageWithBasePath from "../../img/imagewithbasebath";
// import Breadcrumbs from "../../core/breadcrumbs.jsx";
import AddUsers from "../../core/modals/usermanagement/addusers.jsx";
import EditUsers from "../../core/modals/usermanagement/editusers.jsx";
//
import { APIgetUsers, deleteUser } from "../../api/settings.ts";

const StoreList = () => {
  const myRef = useRef(null);
  //
//  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
const translation = useSelector(state => state.root.translation);
  const [dataUser, setDataUser] = useState([]);
  const [editUser, setEditUser] = useState([]);
  const [loading, setLoading] = useState(true);
//  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);

  // const [showAddUserModal, setShowAddUserModal] = useState(false);

  const getUsersApi = async () => {
    try {
      setLoading(true)
      const res = await APIgetUsers({});
      if (res?.response?.users) {
        const userData = res.response.users.reverse();
        const nestData = userData.map((item) => {
          const { fullName, firstName, lastName } = item.profile;
          const role = item.role?.title?item.role.title:"";
          return {
            ...item,
            fullName: !fullName ? firstName : fullName,
            firstName,
            lastName,
            role,
          };
        });
        setDataUser(nestData.reverse());
        setFiltered(nestData.reverse());
        setLoading(false)
      }
    } catch (error) {
      // setLoading(false)
      console.log(error);
    }
  };
  useEffect(() => {
    getUsersApi();
  }, []);
  const editHandler = (record) => {
    // if (myRef.current) {
    //   myRef.current.getLocations(record._id);
    // }
    setEditUser(record);
  };
  //Permissions  
  const permissions = useSelector(state => state.root.permissions) || [];
  const roleTitle = useSelector(state => state.root.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.root.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'users' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'users' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'users' && p.Permission.toLowerCase() === 'update');
  const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'users' && p.Permission.toLowerCase() === 'delete');

  // if (!canView) {
  //     return ( 
  //     <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{translation?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  // )}
  //
  // Static data
  const columns = [
    {
      title: translation?.["name"] || 'Name',
      dataIndex: "fullName",
    },
    {
      title: translation?.["email"] || 'Email',
      dataIndex: "email",
    },
    {
      title: translation?.["role"] || 'Role',
      dataIndex: "role",
    },
    {
      title: translation?.["last_active"] || 'Last Active',
      dataIndex: "lastActive",
      render: (text) => (
          <span className="">
            {text?.date} {text?.time}
              {/* {dateFormatter(text,l)} */}
          </span>
      ),
    },
    {
      title: translation?.["actions"] || 'Actions',
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {/* <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link> */}
            {canUpdate && (
              <Link
                className="me-2 p-2"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
                onClick={() => editHandler(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            )}
            {canDelete && (
            
              <Link
                className="confirm-text p-2"
                to="#"
                onClick={(e) => showConfirmationAlert(e, record)}
              >
                <Trash2 className="feather-trash-2" />
              </Link>
            )}
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);
  const addNew = () => {
    // if (myRef.current) {
    //   myRef.current.resetData();
    // }
    setEditUser({});
  };
  const showConfirmationAlert = async (e,record) => {
    try {
      e.preventDefault();
      const result = await MySwal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#00ff00",
        confirmButtonText: "Yes, delete it!",
        cancelButtonColor: "#ff0000",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        try {
          const res = await deleteUser({ id: record._id});
          if (res) {
            await MySwal.fire({
              title: "Deleted!",
              text: "User has been deleted.",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            getUsersApi()
            // Update data here if necessary
          } else {
            throw new Error("Deletion failed");
          }
        } catch (error) {
          await MySwal.fire({
            title: "Error!",
            text: "An error occurred while deleting the store.",
            icon: "error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        }
      } else {
        MySwal.close();
      }
    } catch (error) {
      console.error("Error during the confirmation process:", error);
    }
  };
  // const addNew = () => {

  //   // AddUser
  //   // if (myRef.current) {
  //   //   myRef.current.resetData();
  //   // }
  //   // setEditUser({});
  // };
  // const addNew = () => {
  //   setShowAddUserModal(true);
  // };
   //  search
   useEffect(() => {
    // Filter data based on search text
    const filtered = dataUser.filter(item =>
      item.fullName.toLowerCase().includes(searchText.toLowerCase())
    );
    if(!searchText){
      setFiltered(dataUser);
    }else{
      setFiltered(filtered);
    }
  }, [searchText]);
  const handleSearch = e => {
    setSearchText(e.target.value);
  };
  // search
  if (loading) {
    return (
      <div className="page-wrapper dashboard-wrapper">
        <div className="dashboard-content loader-content">
          <div id="global-loader">
            <div className="whirly-loader"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
          {canView ? (
        <div className="content">
          {/* <Breadcrumbs
              maintitle={translation?.["user_management"] || "User Management"}
              subtitle={translation?.["manage_your_users"] || "Manage Your Users"}
              addButton={translation?.["add_user"] || "Add User"}
              clicked={addNew}
              addButtonLink="#"

            /> */}
            <div className="page-header">
            <div className="add-item d-flex">
                <div className="page-title">
                    <h4>{translation?.["user_management"] || "User Management"}</h4>
                    <h6>{translation?.["manage_your_users"] || "Manage Your Users"}</h6>
                </div>
            </div>

        {canCreate ? (
          <div className="page-btn">
          <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#add-users"
              onClick={addNew}
          >
              <PlusCircle className="me-2" />
              {translation?.["add_user"] || "Add User"}
          </Link>
          </div>

          // <Breadcrumbs
          //   maintitle={translation?.["user_management"] || "User Management"}
          //   subtitle={translation?.["manage_your_users"] || "Manage Your Users"}
          //   addButton={translation?.["add_user"] || "Add User"}
          //   clicked={addNew}
          // />
        ) : null}
        </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top hidden justify-content-end">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder={translation.search || "Search"}
                      className="form-control form-control-sm formsearch"
                      onChange={(ev) => handleSearch(ev)}
                    />
                    <Link to="#" className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  // loading={loading}
                  className="table datanew"
                  columns={columns}
                  dataSource={filtered}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
        ) : (
          <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
              <div className="content">
                  <p>{t[l]?.["no_permission"] || "You do not have permission to view this page."}</p>
              </div>
          </div>
      )}
      {
        canView && <EditUsers ref={myRef} edit={editUser} refetchUser={getUsersApi} /> 
      }
      {
        <AddUsers refetchUser={getUsersApi} /> 
      }


      </div>
    </div>
  );
};

export default StoreList;
